import { mapToCanActivate, mapToResolve, mapToCanDeactivate } from "@angular/router";
import { ManageModulesComponent } from "./components/modules/manage-modules.component";
import { ContactDetailsComponent } from "./components/contacts/contact-details.component";
import { ManageGroupsComponent } from "./components/groups/manage-groups.component";
import { ManageContactsComponent } from "./components/contacts/manage-contacts.component";
import { GroupDetailsComponent } from "./components/groups/group-details.component";
import { OrganizationComponent } from "./components/organization/organization.component";
import { OrganizationResolver } from "../common/resolvers/organization.resolver";
import { InternalGuardService } from "../auth/guards/internal-guard.service";
import { BaseGuardService } from "../auth/guards/base-guard.service";
import { SystemPermissionGuardService } from "../auth/guards/system-permission-guard.service";
import { LunaClaimValues, LunaClaimTypes } from "../models/user-identity.model";
import { ReminderListComponent } from "./components/reminder-builder/reminder-list/reminder-list.component";
import { ReminderEditComponent } from "./components/reminder-builder/reminder-edit/reminder-edit.component";
import { CommunicationTemplatesComponent } from "./components/communications/communication-templates.component";
import { FaInstrumentDetailsComponent } from "./components/financial-assurance/fa-instrument-details.component";
import { FaInsuranceDetailsComponent } from "./components/financial-assurance/fa-insurance-details.component";
import { WorkOrderResolver } from "../common/resolvers/work-order.resolver";
import { ManageContactsResolver } from "./Resolvers/manage-contacts.resolver";
import { FaInstrumentResolver } from "./Resolvers/fa-instrument.resolver";
import { FaInsuranceResolver } from "./Resolvers/fa-insurance.resolver";
import { ChiefOrdersComponent } from "./components/chief-orders/chief-orders.component";
import { CoLevelConfigComponent } from "./chiefs-orders/co-level-config/co-level-config.component";
import { CoLevelMergeFieldsComponent } from "./chiefs-orders/co-approval/co-level-mergefields/co-level-mergefields.component";
import { CommunicationGetOrg } from "./Resolvers/communication-getorginfo.resolve";
import { CommunicationGetMergeFields } from "./Resolvers/communication-getmergefields.resolve";
import { CoApproveLetterComponent } from "./chiefs-orders/co-approval/co-approve-letter/co-approve-letter.component";
import { ChiefsOrderCoInProg } from "./Resolvers/co-getcoinstance.resolve";
import { CoSubmitChiefsorderComponent } from "./chiefs-orders/co-approval/co-submit-chiefsorder/co-submit-chiefsorder.component";
import { IssueDetailsComponent } from "./components/Issues/issue-details.component";
import { CoReviewChiefsorderComponent } from "./chiefs-orders/co-approval/co-review-chiefsorder/co-review-chiefsorder.component";
import { CoSignatureComponent } from "./chiefs-orders/co-approval/co-signature/co-signature.component";
import { ChiefsOrderGetProfile } from "./Resolvers/co-getprofile.resolve";
import { ChiefsOrderGetContactAuthority } from "./Resolvers/co-getcontactbyauthority";
import { ChiefsOrderSignersList } from "./Resolvers/co-getSignersList";
import { EDiscoveryRequestWrapperComponent } from './components/eDiscovery/request-wrapper/request-wrapper.component';
import { EDiscoveryRequestDetailsComponent } from './components/eDiscovery/request-details/request-details.component';
import { DataCorrectionItemSelectorComponent } from "./components/data-corrections/data-correction-item-selector.component";
import { BondsReportComponent } from "./components/financial-assurance-reports/bonds-report/bonds-report.component";
import { CertificateOfDepositReportComponent } from "./components/financial-assurance-reports/certificateOfDeposits-report/certificate-of-deposit-report.component";
import { SurplusInsurerReportComponent } from "./components/financial-assurance-reports/surplusInsurer-report/surplus-insurer-report.component";
import { ActiveOwnersReportComponent } from "./components/financial-assurance-reports/activeOwners-report/active-owners-report.component";
import { ContactDeletionComponent } from "./components/contacts/contact-deletion/contact-deletion.component";
import { WellTransferReportComponent } from "./components/financial-assurance-reports/wellTransfer-report/well-transfer-report.component";
import { ContactHistoryReportComponent } from "./components/reports/contact-history-report/contact-history-report.component";
import { RequestScanComponent } from './components/scanning/request-scan/request-scan.component';
import { SubmitScanComponent } from "./components/scanning/submit-scan/submit-scan.component";
import { ConfirmScanComponent } from "./components/scanning/confirm-scan/confirm-scan.component";
import { CanDeactivateGuardService } from "../auth/guards/can-deactivate-guard.service";
import { OnBaseInterfaceConfigComponent } from "./components/onbase-interface/onbase-interface-config/onbase-interface-config-component";
import { OnBaseInterfaceUploadComponent } from "./components/onbase-interface/onbase-interface-upload/onbase-interface-upload-component";
import { OnBaseFileUploadReportComponent } from "./components/reports/onbase-file-upload-report/onbase-file-upload-report.component";
import { FailedWellTransferReportComponent } from "./components/financial-assurance-reports/failed-well-transfer-report/failed-well-transfer-report.component";
import { LetterOfCreditTrackingComponent } from "./components/financial-assurance-reports/letters-of-credit-report/letters-of-credit-report.component";
import { CoDetailsComponent } from "./chiefs-orders/co-details/co-details.component";
import { InsuranceDateListingReportComponent } from "./components/financial-assurance-reports/insurance-date-listing-report/insurance-date-listing-report.component";
import { CountyEngineersReportComponent } from "./components/adhoc-reports/county-engineers-report/county-engineers-report.component";
import { ManageInspectorsComponent } from "./components/manage-inspectors/manage-inspectors.component";
import { MasterGuardService } from "../auth/guards/master-guard.service";
import { GuardList } from "../auth/guards/guard-list.enum";
import { PermittingReportsComponent } from "./components/powerbi-reports/permitting-reports/permitting-reports.component";
import { PermitApplicationsReportComponent } from "./components/adhoc-reports/permit-applications-report/permit-applications-report.component";
import { PermitApplicationsTrackingSummaryReportComponent } from "./components/adhoc-reports/permit-applications-tracking-summary-report/permit-applications-tracking-summary-report.component";
import { RegeneratePermitComponent } from './components/regenerate-permit/regenerate-permit.component';
import { LetterMergeFieldsComponent } from "./components/communications/letter-mergefields/letter-mergefields.component";
import { OnBaseQueueStatusComponent } from "./components/reports/onbase-queue-status/onbase-queue-status.component";
import { CompleteProgramComponent } from './components/landowner-passthrough/complete-program/complete-program.component';
import { ViewPassthroughPermitsComponent } from "./components/landowner-passthrough/view-passthrough-permits/view-passthrough-permits.component";
import { LandownerWrapperComponent } from "./components/landowner-passthrough/landowner-wrapper/landowner-wrapper.component";
import { ReserveApiComponent } from './components/reserve-api/reserve-api.component';
import { RegenerateInvoiceReceiptComponent } from "./components/regenerate-invoice-receipt/regenerate-invoice-receipt.component";
import { PermitApplicationsDetailedReportComponent } from "./components/adhoc-reports/permit-applications-detailed-report/permit-applications-detailed-report.component";
import { ApplicationLogComponent } from "./components/reports/application-log/application-log.component";
import { SubmitBulkWellUpdateComponent } from './components/bulk-well-update/submit-bulk-well-update/submit-bulk-well-update.component';
import { ApproveBulkWellUpdateComponent } from "./components/bulk-well-update/approve-bulk-well-update/approve-bulk-well-update.component";
import { InsuranceFullDataListComponent } from './components/reports/insurance-full-data-list/insurance-full-data-list.component';
import { InsuranceComplianceByDateReportComponent } from "./components/reports/insurance-compliance-by-date-report/insurance-compliance-by-date-report.component";
import { LandownerApplicationResolver } from "./Resolvers/landowner-application.resolver";
import { UserPermissionsReportComponent } from './components/reports/user-permissions-report/user-permissions-report.component';
import { StratigraphicWellsReportComponent } from './components/adhoc-reports/stratigraphic-wells-report/stratigraphic-wells-report.component';
import { ComplianceReportComponent } from "./components/reports/compliance-report/compliance-report.component";
import { SystemSettingsComponent } from "./components/system-settings/system-settings.component";
import { SystemAlertsComponent } from "./components/system-alerts/system-alerts.component";
import { DeleteApiComponent } from "./components/delete-api/delete-api.component"; 
import { ApproveNad83UpdatesComponent } from "./components/bulk-nad83/approve-nad83-updates/approve-nad83-updates.component";
import { UploadNad83UpdatesComponent } from "./components/bulk-nad83/upload-nad83-updates/upload-nad83-updates.component";
import { NAD83ReadonlyComponent } from "./components/bulk-nad83/nad83-readonly/nad83-readonly.component";
import { ManageFeesComponent } from "./components/manage-fees/manage-fees.component";
import { ApplicationsResolver } from "../applications/resolvers/applications.resolver";
import { BondingReceivedReportComponent } from "./components/financial-assurance-reports/bonding-received-report/bonding-received-report.component";
import { CollateralReleasedReportComponent } from "./components/financial-assurance-reports/collateral-released-report/collateral-released-report.component";
import { WellsRequiringBondingInsuranceReportComponent } from "./components/reports/wells-requiring-bonding-insurance-report/wells-requiring-bonding-insurance-report";
import { OnBaseProcessName } from "../common/models/onBaseIntegrationAndMapping.model";
import { onBaseDocumentTypesByProcessResolver } from "../common/resolvers/onBaseDocumentTypesByProcess.resolver";

const routeGuards = [BaseGuardService, InternalGuardService];
const routeGuardList = [GuardList.BaseGuardService, GuardList.InternalGuardService];
const systemPermissionGuards = [BaseGuardService, InternalGuardService, SystemPermissionGuardService];
const deactivateGuards = [CanDeactivateGuardService];

const userPermissionGuards = [BaseGuardService, SystemPermissionGuardService];

const manageContactsClaims = [{ type: LunaClaimTypes.System, value: LunaClaimValues.ManageContacts },
                              { type: LunaClaimTypes.System, value: LunaClaimValues.ManageContactsLimited },
                              { type: LunaClaimTypes.System, value: LunaClaimValues.EditContact }]

const viewContactsClaims = [{ type: LunaClaimTypes.System, value: LunaClaimValues.ManageContacts },
                            { type: LunaClaimTypes.System, value: LunaClaimValues.ManageOwnContact },
                            { type: LunaClaimTypes.System, value: LunaClaimValues.ManageContactsLimited }]

export const ADMIN_ROUTES: any = [
    {
        path: "",
        component: ManageModulesComponent,
        canActivate: mapToCanActivate(routeGuards)
    },
    {
        path: "chief-orders",
        children: [
            {
                path: "",
                component: ChiefOrdersComponent,
                canActivate: mapToCanActivate(routeGuards)
            },
            {
                path: "co-level-config",
                component: CoLevelConfigComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.ManageAnyOrganization }
            },             
            {
                path: "co-level-mergefields/:templateId/:orgId/:categoryCode",
                resolve: {
                    orgInfo: mapToResolve(CommunicationGetOrg),
                    mergeInfo: mapToResolve(CommunicationGetMergeFields),
                },
                component: CoLevelMergeFieldsComponent,
                canActivate: mapToCanActivate(routeGuards)
            },
            {
                path: "co-level-mergefields/:templateId/:orgId/:categoryCode/:priorChiefsOrderNumber/:finalStatusForPriorChiefsOrder",
                component: CoLevelMergeFieldsComponent,
                data: { guards: routeGuardList },
                resolve: {
                    orgInfo: mapToResolve(CommunicationGetOrg),
                    mergeInfo: mapToResolve(CommunicationGetMergeFields),
                },
                canActivate: mapToCanActivate([MasterGuardService])
            },
            {
                path: "co-level-mergefields/:chiefsOrderInstanceId",
                component: CoLevelMergeFieldsComponent,
                data: { guards: routeGuardList },
                canActivate: mapToCanActivate([MasterGuardService])
            },
            {
                path: "co-level-mergefields",
                component: CoLevelMergeFieldsComponent,
                data: { guards: routeGuardList },
                canActivate: mapToCanActivate([MasterGuardService])
            },
            {
                path: "co-approve-letter/:coid",
                resolve: {
                    coinprogress: mapToResolve(ChiefsOrderCoInProg)
                },
                component: CoApproveLetterComponent,
                canActivate: mapToCanActivate(routeGuards)
            },
            {
                path: "co-approve-letter",
                component: CoApproveLetterComponent,
                canActivate: mapToCanActivate(routeGuards)
            },
            {
                path: "co-submit-chiefsorder/:coid",
                component: CoSubmitChiefsorderComponent,
                canActivate: mapToCanActivate(routeGuards)
            },
            {
                path: "co-submit-chiefsorder",
                component: CoSubmitChiefsorderComponent,
                canActivate: mapToCanActivate(routeGuards)
            },
            {
                path: "co-review-chiefsorder/:coinstanceid",
                component: CoReviewChiefsorderComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.ManageAnyOrganization }
            },
            {
                path: "co-review-chiefsorder",
                component: CoReviewChiefsorderComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.ManageAnyOrganization }
            },
            {
                path: "co-cancel/:coinstanceid",
                component: CoReviewChiefsorderComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.ManageAnyOrganization }
            },
            {
                path: "co-return/:coinstanceid",
                component: CoReviewChiefsorderComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.ManageAnyOrganization }
            },
            {
                path: "co-edit-letter/:coinstanceid",
                component: CoReviewChiefsorderComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.ManageAnyOrganization }
            },
            {
                path: "co-signature/:coinstanceid",
                resolve: {
                    contactProfile: mapToResolve(ChiefsOrderGetProfile),
                    contactAuthority: mapToResolve(ChiefsOrderGetContactAuthority),
                    signersList: mapToResolve(ChiefsOrderSignersList)
                },
                component: CoSignatureComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.ManageAnyOrganization } 
            },
            {
                path: "co-details/:coinstanceid",
                component: CoDetailsComponent,
                canActivate: mapToCanActivate([BaseGuardService])
            },
        ]
    },
    {
        path: "communications",
        children: [
            {
                path: "",
                component: CommunicationTemplatesComponent,
                data: { guards: routeGuardList },
                canActivate: mapToCanActivate([MasterGuardService])
            },
            {
                path: "letter-mergefields/:templateId/:orgId/:categoryCode",
                resolve: {
                    orgInfo: mapToResolve(CommunicationGetOrg),
                    mergeInfo: mapToResolve(CommunicationGetMergeFields),
                },
                component: LetterMergeFieldsComponent,
                data: { guards: routeGuardList },
                canActivate: mapToCanActivate([MasterGuardService])
            },
        ]
    },
    {
        path: "reminders",
        component: ReminderListComponent,
        canActivate: mapToCanActivate(routeGuards)
    },
    {
        path: "editReminder/:id",
        component: ReminderEditComponent,
        canActivate: mapToCanActivate(routeGuards)
    },

    {
        path: "manage-modules",
        component: ManageModulesComponent,
        canActivate: mapToCanActivate(systemPermissionGuards),
        data: { permission: LunaClaimValues.ManageModules }
    },
    {
        path: "contact/add/:isInternal/:orgId",
        component: ContactDetailsComponent,
        canActivate: mapToCanActivate(userPermissionGuards),
        data: { permission: LunaClaimValues.ManageContacts, claims: manageContactsClaims }
    },
    {
        path: "contact/add/:orgId",
        component: ContactDetailsComponent,
        resolve: { contactGroup: mapToResolve(ManageContactsResolver) },
        canActivate: mapToCanActivate(userPermissionGuards),
        data: { permission: LunaClaimValues.ManageContacts, claims: [{ type: LunaClaimTypes.System, value: LunaClaimValues.ManageContacts }, { type: LunaClaimTypes.System, value: LunaClaimValues.ManageOwnContact }] }
    },
    {
        path: "contact/:id",
        component: ContactDetailsComponent,
        resolve: { contactGroup: mapToResolve(ManageContactsResolver) },
        canActivate: mapToCanActivate(userPermissionGuards),
        data: { permission: LunaClaimValues.EditContact, claims: manageContactsClaims }
    },
    {
        path: "contact/view/:id",
        component: ContactDetailsComponent,
        resolve: { contactGroup: mapToResolve(ManageContactsResolver) },
        canActivate: mapToCanActivate(userPermissionGuards),
        data: { permission: LunaClaimValues.ManageContacts, claims: viewContactsClaims }
    },
    {
        path: "contact/delete/:orgId/:id",
        component: ContactDeletionComponent,
        resolve: { contactGroup: mapToResolve(ManageContactsResolver) },
        canActivate: mapToCanActivate(userPermissionGuards),
        data: { permission: LunaClaimValues.EditContact, claims: manageContactsClaims }
    },
    {
        path: "manage-contacts",
        component: ManageContactsComponent,
        resolve: { organizations: mapToResolve(ManageContactsResolver) },
        canActivate: mapToCanActivate(userPermissionGuards),
        data: { permission: "", claims: manageContactsClaims }
    },
    {
        path: "manage-groups",
        component: ManageGroupsComponent,
        canActivate: mapToCanActivate(systemPermissionGuards),
        data: { permission: LunaClaimValues.ManageGroups }
	},
	{
		path: "manage-fees",
		component: ManageFeesComponent,
		canActivate: mapToCanActivate(systemPermissionGuards),
		canDeactivate: mapToCanDeactivate(deactivateGuards),
		data: { permission: LunaClaimValues.ManageFees }
	},
    {
        path: "group/:id",
        component: GroupDetailsComponent,
        canActivate: mapToCanActivate(systemPermissionGuards),
        data: { permission: LunaClaimValues.ManageGroups }
    },
    {
        path: "group",
        component: GroupDetailsComponent,
        canActivate: mapToCanActivate(systemPermissionGuards),
        data: { permission: LunaClaimValues.ManageGroups }
    },
    {
        path: "organization",
        component: OrganizationComponent,
        resolve: { organization: mapToResolve(OrganizationResolver) },
        canActivate: mapToCanActivate(systemPermissionGuards),
        data: { permission: LunaClaimValues.ManageOwnOrganization }
    },
    {
        path: "bond/:id",
        canActivate: mapToCanActivate(routeGuards),
        component: FaInstrumentDetailsComponent,
        resolve: { instrument: mapToResolve(FaInstrumentResolver) }
    },
    {
        path: "insurance/:id",
        canActivate: mapToCanActivate(routeGuards),
        component: FaInsuranceDetailsComponent,
        resolve: { insurance: mapToResolve(FaInsuranceResolver) }
    },
    {
        path: "issue/:id",
        component: IssueDetailsComponent,
        canActivate: mapToCanActivate(systemPermissionGuards),
        data: { permission: LunaClaimValues.ManageIssues }
    },
    {
        path: "eDiscovery",
        component: EDiscoveryRequestWrapperComponent,
        children: [
            {
                path: "",
                component: EDiscoveryRequestWrapperComponent
            }
        ],
        canActivate: mapToCanActivate(systemPermissionGuards),
        data: { permission: LunaClaimValues.InitiateEDiscovery }
    }, 
    {
        path: "eDiscovery/org/:organizationId",
        data: { permission: LunaClaimValues.InitiateEDiscovery },
        component: EDiscoveryRequestWrapperComponent,
        resolve: { organization: mapToResolve(OrganizationResolver) },
        canActivate: mapToCanActivate(systemPermissionGuards)       
    },
    {
        path: "eDiscovery/request/:requestId",
        data: { permission: LunaClaimValues.InitiateEDiscovery },
        component: EDiscoveryRequestDetailsComponent,
        canActivate: mapToCanActivate(systemPermissionGuards)
    },
    {
        path: "data-corrections",
        component: DataCorrectionItemSelectorComponent,
        canActivate: mapToCanActivate(systemPermissionGuards),
        data: { permission: LunaClaimValues.InitiateDataCorrection }
    }, 
    {
        path: "data-corrections/:id",
        component: DataCorrectionItemSelectorComponent,
        canActivate: mapToCanActivate(systemPermissionGuards),
        data: { permission: LunaClaimValues.InitiateDataCorrection }
    },
    {
        path: "data-corrections/:id/:workOrderId",
        component: DataCorrectionItemSelectorComponent,
        canActivate: mapToCanActivate(routeGuards)
    }, 
    {//give them permission explicity should they need to change per report
        path: "financial-assurance-reports",       
        children: [
            {
                path: "bonds-report",
                component: BondsReportComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.SuretyReport },
            },
            {
                path: "certificate-of-deposit-report",
                component: CertificateOfDepositReportComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.SuretyReport },
            },
            {
                path: "surplus-insurer-report",
                component: SurplusInsurerReportComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.SuretyReport },
            },
            {
                path: "active-owners-report",
                component: ActiveOwnersReportComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.SuretyReport },
            },
            {
                path: "well-transfer-report",
                component: WellTransferReportComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.SuretyReport },
            },
            {
                path: "failed-well-transfer-report",
                component: FailedWellTransferReportComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.SuretyReport },
            },
            {
                path: "letter-of-credit-report",
                component: LetterOfCreditTrackingComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.SuretyReport },
            },
            {
                path: "insurance-date-listing-report",
                component: InsuranceDateListingReportComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.SuretyReport },
            },
            {
                path: "bonding-received-report",
                component: BondingReceivedReportComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.SuretyReport },
            },
            {
                path: "collateral-released-report",
                component: CollateralReleasedReportComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.SuretyReport },
            }
        ] 
    },
    {
        path: "reports", 
        children: [
            {
                path: "contact-history",
                component: ContactHistoryReportComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.ContactHistoryReport }
            },
            {
                path: "file-upload-history",
                component: OnBaseFileUploadReportComponent,
				canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.FileUploadHistoryReport }
            },
            {
                path: "county-engineers-report",
                component: CountyEngineersReportComponent,
				canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.SuretyReport}
            },
            {
                path: "permit-applications-tracking-summary-report",
                component: PermitApplicationsTrackingSummaryReportComponent,
				canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.SuretyReport}
            },
            {
                path: "permit-applications-detailed-report",
                component: PermitApplicationsDetailedReportComponent,
				canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.SuretyReport}
            },
            {
                path: "permitting-reports",
                component: PermittingReportsComponent,
				canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.SuretyReport}
            },
            {
                path: "permit-applications-report",
                component: PermitApplicationsReportComponent,
				canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.SuretyReport}
            },
            {
                path: "document-queue",
                component: OnBaseQueueStatusComponent,
                canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                    permission: LunaClaimValues.OnBaseManagement
                }
            },
            {
                path: "application-log",
                component: ApplicationLogComponent,
				canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                    permission: LunaClaimValues.ViewApplicationLog
                }
            },
            {
                path: "insurance-full-data-list",
                component: InsuranceFullDataListComponent,
				canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                    permission: LunaClaimValues.InsuranceFullDataListReport
                }
            },
            {
                path: "insurance-compliance-by-date",
                component: InsuranceComplianceByDateReportComponent,
				canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                    permission: LunaClaimValues.InsuranceComplianceByDateReport
                }
            },
            {
                path: "user-permissions",
                component: UserPermissionsReportComponent,
				canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                    permission: LunaClaimValues.ViewUserPermissionsReport
                }
            },
            {
                path: "permit-stratigraphic-applications-report",
                component: StratigraphicWellsReportComponent,
				canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                    permission: LunaClaimValues.SuretyReport
                }
            },
            {
                path: "compliance-reporting-report",
                component: ComplianceReportComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: {
                    permission: LunaClaimValues.ViewComplianceReport
                }

            },
            {
                path: "wells-requirement-report",
                component: WellsRequiringBondingInsuranceReportComponent,
				canActivate: mapToCanActivate(systemPermissionGuards),
                data: {
                    permission: LunaClaimValues.ViewAllWellsRequiringBondingInsuranceReport
                }
            },
            {
                path: "system-alerts",
                component: SystemAlertsComponent,
				canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                   guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                   permission: LunaClaimValues.ViewSystemAlerts
                }
            }
        ]
    },
    {
        path: "scanning",
        children: [
            {
                path: "confirm/:workOrderId",
                component: ConfirmScanComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                resolve: { workOrder: WorkOrderResolver },
                data: { permission: LunaClaimValues.RequestDocumentScanning }
            },
            {
                path: "request/:workOrderId",
                component: SubmitScanComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                canDeactivate: deactivateGuards,
                resolve: { workOrder: WorkOrderResolver },
                data: { claims: [{ type: LunaClaimTypes.Widget, value: LunaClaimValues.ViewScanningWidget }, { type: LunaClaimTypes.System, value: LunaClaimValues.ManageWorkOrders }] }
            },
            {
                path: "new-request",
                component: RequestScanComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.RequestDocumentScanning }
            },
            {
                path: "",
                component: RequestScanComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.RequestDocumentScanning }
            }
        ]
    },
    {
        path: "onbase-document-management",
        children: [
            {
                path: "config",
                component: OnBaseInterfaceConfigComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.OnBaseManagement }
            },
            {
                path: "upload",
                // component: OnBaseInterfaceUploadComponent,
                // canActivate: mapToCanActivate(systemPermissionGuards),
                redirectTo: "/home"
                // data: { permission: LunaClaimValues.OnBaseManagement }
            },            
            {
                path: "",
                component: OnBaseInterfaceConfigComponent,
                canActivate: mapToCanActivate(systemPermissionGuards),
                data: { permission: LunaClaimValues.OnBaseManagement }
            }
        ]
    },
    {
        path: "manage-inspectors",
        children: [
            {
                path: "",
                component: ManageInspectorsComponent,
                canActivate: [ MasterGuardService ],
                data: {
                    guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                    permission: LunaClaimValues.ManageInspectorList
                },
                canDeactivate: [CanDeactivateGuardService]
            }
        ]
        
    },
    {
        path: "regenerate-permit",
        children: [
            {
                path: "",
                component: RegeneratePermitComponent,
                canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                    permission: LunaClaimValues.RegeneratePermits
                }
            }
        ]
    },
    {
        path: "regenerate-invoices-receipts",
        children: [
            {
                path: "",
                component: RegenerateInvoiceReceiptComponent,
                canActivate: mapToCanActivate([MasterGuardService]),
                canDeactivate: deactivateGuards,
                data: {
                    guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                    permission: LunaClaimValues.OnBaseManagement
                }
            }
        ]
    },
    {
        path: "landowner-passthrough",
        children: [
            {
                path: "complete/:id",
                component: CompleteProgramComponent,
                canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                    permission: LunaClaimValues.LandOwnerPassThroughProgram
                },
                canDeactivate: [CanDeactivateGuardService],
                resolve: {
                    application: mapToResolve(LandownerApplicationResolver),
                    documentTypes: onBaseDocumentTypesByProcessResolver(OnBaseProcessName.LandownerPassthrough)
                }
            },
            {
                path: "view-permits",
                component: ViewPassthroughPermitsComponent,
                canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                    permission: LunaClaimValues.LandOwnerPassThroughProgram
                },
                canDeactivate: [CanDeactivateGuardService]
            },
            {
                path: "edit/:id",
                component: LandownerWrapperComponent,               
                canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                    permission: LunaClaimValues.LandOwnerPassThroughProgram
                },
                canDeactivate: [CanDeactivateGuardService],
                resolve: {
                    application: mapToResolve(LandownerApplicationResolver),
                    documentTypes: onBaseDocumentTypesByProcessResolver(OnBaseProcessName.LandownerPassthrough)
                }
            },
            {
                path: "review/:id",
                component: LandownerWrapperComponent, 
                canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                    permission: LunaClaimValues.ApproveLandownerPassthroughProgramApplication
                },
                canDeactivate: [CanDeactivateGuardService],
                resolve: {
					application: mapToResolve(LandownerApplicationResolver),
                    documentTypes: onBaseDocumentTypesByProcessResolver(OnBaseProcessName.LandownerPassthrough)
                }
            },
            {
                path: "",
                component: LandownerWrapperComponent,               
                canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                    permission: LunaClaimValues.LandOwnerPassThroughProgram
                },
                resolve: {
					documentTypes: onBaseDocumentTypesByProcessResolver(OnBaseProcessName.LandownerPassthrough)
                },
                canDeactivate: mapToCanDeactivate([CanDeactivateGuardService])
            }
        ]
    },
    {
        path: "reserve-api",
        children: [
            {
                path: "",
                component: ReserveApiComponent,
                canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                    permission: LunaClaimValues.ReserveAPINumber
                }
            }
        ]
    },
    {
        path: "bulk-well-status-update",
        children: [
            {
                path: ":id",
                component: ApproveBulkWellUpdateComponent,
                canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                    permission: LunaClaimValues.ApproveBulkWellStatusChanges
                }                
            },
            {
                path: "",
                component: SubmitBulkWellUpdateComponent,
                canActivate: mapToCanActivate([MasterGuardService]),
                data: {
                    guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                    permission: LunaClaimValues.InitiateDataCorrection
                },
                canDeactivate: mapToCanDeactivate([CanDeactivateGuardService])
            }
        ]
	},
	{
		path: "bulk-nad83-update",
		children: [
			{
				path: "review/:id",
				component: ApproveNad83UpdatesComponent,
				canActivate: mapToCanActivate([MasterGuardService]),
				resolve: {
					application: mapToResolve(ApplicationsResolver)
				},
				data: {
					guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
					permission: LunaClaimValues.ApproveBulkUploadNad83LatLong
				},
				canDeactivate: mapToCanDeactivate([CanDeactivateGuardService])
			},
			{
				path: "complete/:id",
				component: NAD83ReadonlyComponent,
				canActivate: mapToCanActivate([MasterGuardService]),
				resolve: {
					application: mapToResolve(ApplicationsResolver)
				},
				data: {
					guards: [GuardList.InternalGuardService]
				}
			},
			{
				path: ":id",
				component: UploadNad83UpdatesComponent,
				canActivate: mapToCanActivate([MasterGuardService]),
				resolve: {
					application: mapToResolve(ApplicationsResolver)
				},
				data: {
					guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
					permission: LunaClaimValues.BulkUploadNAD83LatLong
				},
				canDeactivate: mapToCanDeactivate([CanDeactivateGuardService])
			},
			{
				path: "",
				component: UploadNad83UpdatesComponent,
				canActivate: mapToCanActivate([MasterGuardService]),
				data: {
					guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
					permission: LunaClaimValues.BulkUploadNAD83LatLong
				},
				canDeactivate: mapToCanDeactivate([CanDeactivateGuardService])
			}
		]
	},
	{
		path: "system-settings",
		children: [
			{
				path: "",
				component: SystemSettingsComponent,
				canActivate: mapToCanActivate([MasterGuardService]),
				data: {
					guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
					permission: LunaClaimValues.ManageSystemSettings
				},
				canDeactivate: mapToCanDeactivate([CanDeactivateGuardService])
			}
		]
    },
    {
        path: "delete-api",
        children: [
            {

            path: "",
            component: DeleteApiComponent,
            canActivate: mapToCanActivate([MasterGuardService]),
            data: {
                guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
                permission: LunaClaimValues.CanDeleteApiNumbers
            }
            }

        ]
        

    }
]

